import { interpolateTranslation } from '@bts-web/utils-lokalise';
import {
  getTransactionListTitleTranslationKeywordByType,
  transactionItemInvertedTranslations,
  TransactionTypes,
} from '../types/transactions';
import { getTransactionTagByType } from './transactions';

export const useTransactionTitle = <T>({
  transactionType,
  symbol,
  symbolTo,
  translations,
  useSimpleTitle,
}: {
  transactionType: TransactionTypes;
  symbol?: string | null;
  symbolTo?: string | null;
  translations: T;
  useSimpleTitle?: boolean;
}) => {
  if (useSimpleTitle) {
    return { title: '', tagValue: null };
  }

  const tagKey: string | null = getTransactionTagByType(transactionType);

  const translationKey =
    getTransactionListTitleTranslationKeywordByType(transactionType);

  const titleKey = transactionItemInvertedTranslations[translationKey];

  return {
    title: interpolateTranslation(translations[titleKey as keyof T] as string, {
      0: symbol,
      1: symbolTo,
    }),
    tagValue: tagKey
      ? translations[
          transactionItemInvertedTranslations[
            tagKey as keyof typeof transactionItemInvertedTranslations
          ] as keyof T
        ]
      : null,
  };
};
